import { render, staticRenderFns } from "./TagDeleteNotification.vue?vue&type=template&id=752c4422&scoped=true"
import script from "./TagDeleteNotification.vue?vue&type=script&lang=js"
export * from "./TagDeleteNotification.vue?vue&type=script&lang=js"
import style0 from "./TagDeleteNotification.vue?vue&type=style&index=0&id=752c4422&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752c4422",
  null
  
)

export default component.exports